<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19EkWlq/media/FC-9781398415553.jpg?1684514526520" alt="This image is the cover for the book Vorclaw"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vorclaw
      </h1>
      <p class="bookDescription body article font2">
        <p>Spurred on by the unexpected loss of his wife, the military officer Baltus Blackpool plans to enact his revenge by dismantling the decadent ruling council of Vorclaw by building his own cult—The Black Masks! Meanwhile, his son Dru bonds with others and delves into a less respectable career path that his father is forced to embrace. Magnus Foehammer, the infallible right hand of Baltus, rears an orphaned elf he names Leif. The elf, raised as a human alongside his adopted brother Bjorn, has no memory of his past but has an uncanny propensity towards good. Leif and Bjorn bond with Dru Blackpool and all three follow their own fathers’ footsteps into the army. However, they get caught up in Baltus Blackpool’s plans to overtake the Vorclaw while falling into their own misfortunes involving deceit, magic and a quest to save Leif from the vampiress and her arch-goblin hoards!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jason Kalinowski
      </h2>
      
      <p class="authorDescription body article">Jason was born in Pittsburgh Pennsylvania in 1974. Since he was eight years old, he delved into science fiction and fantasy, following the works of J.R.R. Tolkien and Gary Gygax. His favourite book however, is Great Expectations by Charles Dickens. Jason began writing during his many deployments and travels as a member of the United States Air Force. After travelling all over Europe and the Middle East for nearly 24 years in the military, he is ready to put writing at the forefront of his life. Jason’s true motivations are his daughters Eve and Ella who have read more books by the time they became teenagers than he had in his entire life!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d6ae2d8